import { render, staticRenderFns } from "./summary-score-global.vue?vue&type=template&id=40da4a68&"
import script from "./summary-score-global.vue?vue&type=script&lang=js&"
export * from "./summary-score-global.vue?vue&type=script&lang=js&"
import style0 from "./summary-score-global.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports